import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bot, Activity, Target } from "lucide-react";
import { Loading } from "@/pages/_shared";
import api from "@/lib/api";

export default function ControlRoom() {
  const [missions, setMissions] = useState(null);
  useEffect(() => { api.get("/missions").then(({ data }) => setMissions(data.missions)).catch(() => setMissions([])); }, []);
  if (!missions) return <Loading />;
  const active = missions.filter((m) => m.status !== "Completed" && m.status !== "Complete");
  return (
    <div className="animate-fade-up space-y-6" data-testid="control-room-page">
      <div>
        <h1 className="font-head text-2xl font-extrabold tracking-tight text-slate-900">AI Control Room</h1>
        <p className="mt-1 text-[13px] text-slate-500">Live view of the AI Controller coordinating your Capital Crew.</p>
      </div>
      <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-[#080d1a] p-5 text-white">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/10"><Bot size={24} /></span>
        <div>
          <div className="font-head text-[15px] font-bold">AI Controller · COO</div>
          <div className="text-[12px] text-slate-300">Online · {active.length} active mission{active.length === 1 ? "" : "s"} · coordinating handoffs</div>
        </div>
        <Link to="/owner" className="ml-auto rounded-xl bg-white px-4 py-2 text-[13px] font-bold text-[#080d1a]">Open Command Center</Link>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="mb-3 flex items-center gap-2"><Activity size={15} className="text-[#1a5fd0]" /><span className="font-head text-[14px] font-bold text-slate-900">Recent missions</span></div>
        {missions.length === 0 ? <div className="py-8 text-center text-[13px] text-slate-400">No missions yet.</div> : (
          <div className="space-y-2">
            {missions.slice(0, 8).map((m) => (
              <Link to={`/owner/missions/${m.id}`} key={m.id} className="flex items-center justify-between rounded-lg border border-slate-100 px-4 py-2.5 hover:bg-slate-50">
                <div className="flex items-center gap-2.5 min-w-0"><Target size={15} className="shrink-0 text-[#1a5fd0]" /><span className="truncate text-[13px] text-slate-700">{m.title}</span></div>
                <span className="ml-3 shrink-0 font-mono text-[9px] uppercase text-amber-600">{m.status}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
